const ENDPOINT_MY_PLACES = '/secure/centers/places/:centerId'
const ENDPOINT_FAVORITE_PLACES = '/secure/centers/:centerId/places/favorite'
const ENDPOINT_MANAGE_PLACE_FROM_CENTER_FAVORITES =
  '/secure/centers/:centerId/places/favorite/:placeId'
const ENDPOINT_REQUEST_PLACE_AUTHORIZATION =
  '/secure/centers/:centerId/places/favorite/:placeId'
const ENDPOINT_SEARCH_PLACE = '/search/place'
const ENDPOINT_PLACE_ACCESSES = '/placeaccesses?sort=weight&order=asc'
const ENDPOINT_PLACE_ENERGY_SOURCES = '/energysources?sort=weight&order=asc'
const ENDPOINT_PLACE_OPTIONS = '/placeoptions?sort=weight&order=asc'
const ENDPOINT_PLACE_TYPES = '/placetypes'
const ENDPOINT_CREATE_PLACE = '/secure/places'
const ENDPOINT_MANAGE_PLACE = '/secure/places/:placeId'
const ENDPOINT_GET_PLACE = '/places/:placeId'

export const state = () => ({})

export const mutations = {}

export const getters = {}

export const actions = {
  async fetchMyPlaces({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_MY_PLACES.replace(':centerId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response.data)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchFavoritePlaces({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_FAVORITE_PLACES.replace(':centerId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async requestPlaceAuthorization({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.put(
        ENDPOINT_REQUEST_PLACE_AUTHORIZATION.replace(
          ':centerId',
          payload.centerId
        ).replace(':placeId', payload.placeId),
        { authorization: payload.authorization }
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async addPlaceToCenterFavorites({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(
        ENDPOINT_MANAGE_PLACE_FROM_CENTER_FAVORITES.replace(
          ':centerId',
          payload.centerId
        ).replace(':placeId', payload.placeId)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async removePlaceFromCenterFavorites({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_MANAGE_PLACE_FROM_CENTER_FAVORITES.replace(
          ':centerId',
          payload.centerId
        ).replace(':placeId', payload.placeId)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async searchPlaces({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(ENDPOINT_SEARCH_PLACE, {
        name: payload
      })
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchPlaceAccesses({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(ENDPOINT_PLACE_ACCESSES)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchPlaceEnergySources({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(ENDPOINT_PLACE_ENERGY_SOURCES)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchPlaceOptions({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(ENDPOINT_PLACE_OPTIONS)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async fetchPlaceTypes({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(ENDPOINT_PLACE_TYPES)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async createPlace({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.post(ENDPOINT_CREATE_PLACE, payload)
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async deletePlace({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.delete(
        ENDPOINT_MANAGE_PLACE.replace(':placeId', payload)
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async updatePlace({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.put(
        ENDPOINT_MANAGE_PLACE.replace(':placeId', payload.placeId),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  },
  async getPlace({ commit, rootState }, payload) {
    try {
      // throws TypeError this.$axios is undefined
      const response = await this.$axios.get(
        ENDPOINT_GET_PLACE.replace(':placeId', payload),
        payload.model
      )
      //      console.log(response)
      return Promise.resolve(response)
    } catch (e) {
      // eslint-disable-next-line
      console.log(e)
      return Promise.reject(e)
    }
  }
}
